// extracted by mini-css-extract-plugin
export default {"container":"ServerHealth_container__f3xqb","button":"ServerHealth_button__8iK2g"};